<template>
  <div v-loading="loading" class="income-summary-v2-list-container">
    <div class="head flex-align-center">
      <div style="display: flex;align-items: center;">

          <el-date-picker
              style="margin-right: 10px"
              v-model="query.date_range"
              type="monthrange"
              align="right"
              size="mini"
              unlink-panels
              format="yyyy年MM月"
              value-format="yyyy-MM"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :picker-options="pickerOptions">
          </el-date-picker>


        <el-date-picker v-model="query.collect_at"
                        type="month"
                        format="yyyy年MM月"
                        value-format="yyyy-MM"
                        placeholder="搜索月份"
                        size="mini"
                        @change="handelSearch"
                        style="margin-right: 10px"
        />

        <select-artist :value.sync="query.artist_id" size="mini" @change="handelSearch"/>
        <el-button type="primary" size="mini" icon="el-icon-search" @click="handelSearch" style="margin:0 10px;">
          查询
        </el-button>
        <el-button size="mini" icon="el-icon-refresh" @click="handleRunScript" style="margin:0 10px;">刷新数据</el-button>
      </div>
    </div>

    <div style="height: calc(100% - 96px)">
      <!--    广告订单列表表格  -->
      <div class="tableCon" ref="tblDiv" style="height:calc(100% - 16px)">
        <el-table :data="tableData"
                  @sort-change="eventSortMethod">
          <el-table-column type="selection" width="55"/>
          <el-table-column label="#" type="index"/>
          <el-table-column label="汇总月份" prop="collect_at" sortable width="120">
            <template v-slot="{row:{collect_at}}">
              <b>{{ collect_at|parseTime('{y}年{m}月') }}</b>
            </template>
          </el-table-column>
          <el-table-column label="红人名称" prop="nickname" show-overflow-tooltip width="130"/>
          <el-table-column label="平台" prop="platform" show-overflow-tooltip width="80"/>
          <el-table-column label="保量金额" prop="stage_amount" header-align="right" align="right" sortable width="120">
            <template v-slot="{row:{stage_amount}}">
              <b>￥{{ stage_amount|numberFormat(2) }}</b>
            </template>
          </el-table-column>
          <el-table-column label="商务收入" prop="biz_amount" header-align="right" align="right" sortable width="120">
            <template v-slot="{row:{biz_amount}}">
              <b>￥{{ biz_amount|numberFormat(2) }}</b>
            </template>
          </el-table-column>
          <el-table-column label="坑位费/线下结佣" prop="live_pit_fee" header-align="right" align="right" sortable width="180">
            <template v-slot="{row:{live_pit_fee}}">
              <b>￥{{ live_pit_fee|numberFormat(2) }}</b>
            </template>
          </el-table-column>
          <el-table-column label="分成金额" prop="artist_rate_amount" header-align="right" align="right" sortable width="180">
            <template v-slot="{row:{artist_rate_amount}}">
              <b>￥{{ artist_rate_amount|numberFormat(2) }}</b>
            </template>
          </el-table-column>
          <el-table-column label="订单数" prop="order_count" header-align="right" align="right" sortable width="120" />
          <el-table-column label="创建时间" prop="created_at" align="center" show-overflow-tooltip/>
          <el-table-column label="更新时间" prop="updated_at" align="center" show-overflow-tooltip/>
        </el-table>
        <div>
          <el-row>
            <el-col :span="12">
              <div class="bottom-bar" />
            </el-col>
            <el-col :span="12" style="text-align: right">
              <el-pagination
                  background
                  :current-page="query.page"
                  :page-sizes="[5,10,20,100, 200, 300, 400]"
                  :page-size="query.page_size"
                  layout="total, sizes, prev, pager, next"
                  :total="query.total"
                  style="margin-top: 10px;float: right;"
                  @current-change="handleCurrentChange"
                  @size-change="eventSizeChange"
              />
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

// 全局方法
import SelectArtist from "@/components/Selects/artist.vue";
// import ExportBtn from "@/components/export/ExportBtn.vue";
import { incomeSummaryV2List, incomeSummaryV2RunScript } from "@/api/incomeSummary";
import moment from "moment/moment";


export default {
  name: "adOrderIndex",
  components: {
    SelectArtist,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      doLoading: false,
      query: {
        page: 1,
        page_size: 20,
        total: 0,
        order_by: null,
        collect_at: null,
        artist_id: null,
        date_range:[]
      },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  created() {
    this.query.collect_at = moment().subtract(1, 'month').format('YYYY-MM');
    this.getTableData(true)
  },
  computed: {
    height() {
      // return 800
      return window.screen.height - this.topHeight - 50
      // return '100%'
    },
  },
  methods: {
    eventSizeChange: function (page_size) {
      this.query.page_size = page_size
      this.handelSearch()
    },
    eventSortMethod: function ({order, prop}) {
      let string = null;
      switch (order) {
        case 'descending':
          string = `${prop} desc`
          break;
        case 'ascending':
          string = `${prop} asc`
          break;
        default:
          break;
      }
      this.query.order_by = string
      this.getTableData(true)
    },
    handelSearch: function () {
      this.getTableData(true)
    },
    async handleRunScript() {
      let year = moment().format('YYYY')
      let month = moment().format('MM')
      if (this.query.collect_at){
        year = moment(this.query.collect_at).format('YYYY')
        month = moment(this.query.collect_at).format('MM')
      }

      //执行权限更新
      const string_s = `${year}年${month}月`;
      this.$confirm(
          `确定更新<b>${string_s}</b>数据吗？`,
          '更新收入汇总v2数据',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(async () => {
            this.doLoading = true
            await incomeSummaryV2RunScript({Ym: year + '-' + month})
            this.msgSuccess('更新任务已发布，请稍后点击查询是否更新')
            setTimeout(() => {
              this.doLoading = false
            }, 500)
          })
    },
    handleCurrentChange: function (page) {
      this.query.page = page
      this.getTableData()
    },
    getSearch: function () {
      this.query.date_check = this.query.date_check ? moment(this.query.date_check).format('YYYY-MM') + '-01' : null
      return this.query
    },
    getTableData: async function (is_search = false) {
      this.sum_amount = 0;
      // this.selectedData = []
      // 查询重置 page
      if (is_search) {
        this.query.page = 1
        this.total_amount = 0;
      }
      this.getSearch()
      this.loading = true
      const { success, model } = await incomeSummaryV2List(this.query)
      this.loading = false
      if (!success) {
        return;
      }
      const { data, total, sum_amount } = model
      this.tableData = data || []
      this.query.total = total || 0
      this.total_amount = sum_amount || 0
    },
    changeTableSort(_) {
      const {prop, order} = _
      let order_by = null
      if (order) {
        order_by = order === 'ascending' ? `\`${prop}\` asc` : `\`${prop}\` desc`
      }
      this.queryParams.order_by = order_by
      this.getTableData()
    },
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2)
    },
  }
};
</script>


<style lang="scss">
.income-summary-v2-list-container {
  padding: 5px 0 5px 5px;
  height: calc(100vh - 166px);

  .el-table .red-row {
    background: #ffeeee;
  }

  .el-table thead tr, .el-table thead th {
    background: white !important;
    color: #3c3c3c !important;
    font-weight: 600;
  }

  .flag-error {
    display: inline-block;
    width: auto;
    line-height: 17px;
    padding: 0 10px;
    border-radius: 9px;
    //border: 1px solid #ab0707;
    color: #FFFFFF;
    background-color: #ab0707;
    font-size: 12px;
    cursor: pointer;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;

    .el-select {
      //width: 250px;
      margin-right: 12px;
    }
  }

  .ape-table-container {
    height: calc(100% - 206px) !important;
  }

  .tip-time {
    color: #8a8e99;
    font-size: 12px;
    margin-right: 10px;
  }

  .tip-help {
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 8px 24px;
    overflow-y: auto;
    background-color: #FFF9FBFC;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 22px;
    color: #666;
    border-radius: 9px;
    position: relative;
    box-sizing: border-box;
    height: 110px;
  }

  .tag {
    border-radius: 3px;
    background-color: #ffeef3;
    color: #fe346e;
    font-size: 12px;
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
  }

  .el-table .cell {
    height: auto !important;
  }

  .el-table th.el-table__cell > .cell {
    min-height: 34px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-table .sort-caret.ascending {
    top: 7px !important;
  }

  .el-table .sort-caret.descending {
    bottom: 5px !important;
  }

  .over-hidden {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .live-sm:hover {
    .live-sm__mark {
      opacity: .7 !important;
    }
  }

  .live-sm {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    position: relative;
    cursor: pointer;

    &__mark {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #111;
      opacity: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;

      span {
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
}
</style>
